module.exports = __webpack_public_path__ + "img/18.958ff91a.png";